import AdminSidebar from "./AdminSidebar";
import WorkspaceSidebar from "./WorkspaceSidebar";
import WorkspaceSwitcher from "./WorkspaceSwitcher";

export default {
  Admin: AdminSidebar,
  Workspace: WorkspaceSidebar,
  Switcher: WorkspaceSwitcher,
};
